import PageProtected from "../../../components/Page/PageProtected";
import Grid from '@mui/material/Grid';
import SectionMeeting from "./SectionMeeting";


export default function MeetingWelcome() {
   
return (
<>

<PageProtected

        headline="Video Conferencing -"
        specify="Counseling"
        
        main={<>

        <Grid container > 
               
               <Grid item xs={12}>  <SectionMeeting /> </Grid>
              
        </Grid>

 </>}
/>

</>
)}